import {Component, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-list-item-detailed",
    templateUrl: "./list-item-detailed.component.html",
    styleUrls: ["./list-item-detailed.component.scss"],
})
export class ListItemDetailedComponent {}
